<template>
  <transition :name="transitionName">
    <div :class="classObj" :style="styleObj" class="app-loading">
      <ProgressCircular
        :size="size"
        :width="width"
        class="app-loading__loading"
        indeterminate
      />
    </div>
  </transition>
</template>

<script>
import { convertToUnit } from "@utils/helpers";
import { ProgressCircular } from "@/components/ui/progress-bar";

export default {
  name: "AppLoading",
  components: {
    ProgressCircular
  },
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    width: {
      type: Number,
      default: 3
    },
    position: {
      type: String,
      default: "",
      validator: value =>
        ["", "center", "top-right", "top-center"].includes(value)
    },
    transition: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classObj() {
      return {
        [`app-loading_${this.position}`]: this.position
      };
    },
    styleObj() {
      return {
        width: convertToUnit(this.size),
        height: convertToUnit(this.size)
      };
    },
    transitionName() {
      return this.transition ? "loading-blast" : "";
    }
  }
};
</script>

<style lang="scss">
.app-loading {
  font-size: 0;
  filter: drop-shadow(0 0 6px #000);

  &_center,
  &_top-center,
  &_top-right {
    position: absolute;
    z-index: 5;
  }

  &_top-right {
    right: -15px;
    top: 0;
  }

  &_top-center {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &_center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.loading-blast-leave-active {
  transition: all 0.3s ease;
}
.loading-blast-leave-to {
  .app-loading__loading {
    opacity: 0;
    transform: scale(1.25);
  }
}
</style>
